import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ProfilePage } from '@/features/auth/components/ProfilePage';

export const Route = createFileRoute('/_auth/profile')({
  component: () => (
    <ErrorBoundary moduleName="Profile">
      <Suspense fallback={<PageLoader />}>
        <ProfilePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
